import PropTypes from 'prop-types';
import { Flex, Heading, Text, Image, Container } from '@qga/roo-ui/components';
import { alertIllustration } from '@qga/roo-ui/assets';
import { rem } from 'polished';

const errorImageWidth = [rem(48), rem(64)];

const BaseErrorPage = ({ title, children }) => (
  <Flex flex="1 0 auto" textAlign="center" alignItems="center" justifyContent="center" flexDirection="column" pt={[15, 12]} pb={[15, 25]}>
    <Container>
      <Image inline src={alertIllustration} alt="Exclamation mark" width={errorImageWidth} mb={[8, 5]} />
      <Heading.h1 fontSize="2xl" lineHeight="tight" mb={5}>
        {title}
      </Heading.h1>
      <Text as="div" fontSize="lg" lineHeight="normal">
        {children}
      </Text>
    </Container>
  </Flex>
);

BaseErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default BaseErrorPage;
